const LinkNewTab = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000000"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}

      <path
        d="M9.70831 14.1025L21.375 2.625"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M21.375 9.18417V2.625H14.7083"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12.1042 6.79163H3.35417C3.16078 6.79163 2.97531 6.86845 2.83857 7.00519C2.70182 7.14194 2.625 7.32741 2.625 7.52079V20.6458C2.625 20.8392 2.70182 21.0246 2.83857 21.1614C2.97531 21.2981 3.16078 21.375 3.35417 21.375H16.4792C16.6726 21.375 16.858 21.2981 16.9948 21.1614C17.1315 21.0246 17.2083 20.8392 17.2083 20.6458V11.8958"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default LinkNewTab;
